import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import firebase from '../firebase.js'

export class InfoPanelEditPage extends Component {
    constructor() {
        super()
        this.state = {
            infoPanel: null,
        }
        this.scenarioTimeRef = undefined
        this.rememberedTimeCallback = undefined
    }

    componentDidMount() {
        const itemsRef = firebase
            .database()
            .ref(`infoPanel/${this.props.match.params.panelId}/`)

        itemsRef.on('value', snapshot => {
            let item = snapshot.val()
            this.setState({
                infoPanel: item,
            })
        })
        // read query params and then follow table or scenario
        let params = new URLSearchParams(window.location.search)
        let tableName = params.get('table')
        let scenarioName = params.get('scenario')
        if (tableName) {
            this.listenToTable(tableName)
        } else if (scenarioName) {
            this.listenToScenarioTime(scenarioName)
        } else {
            this.setState({
                errorMessage:
                    'not following table or scenario. Try ?table=cody_localhost in the adress ',
            })
            //console.log('%c !!! Not Following a Table !!!', 'background: black; color: red; display: block;');
        }
    }

    listenToTable(tableName) {
        var tableRef
        console.log('following table', tableName)
        tableRef = firebase
            .database()
            .ref('deviceRegistration')
            .child(tableName)
            .child('scenarioID')
        tableRef.on('value', ev => {
            let val = ev.val()
            if (!val) {
                this.setState({
                    errorMessage:
                        'ScenrioID was empty. Maybe the table ID was wrong',
                })
                // console.log('%c ScenrioID was empty. Maybe the table ID was wrong ', 'background: black; color: red; display: block;');
                return
            }
            this.setState({ scenarioID: val })
            this.listenToScenarioTime(val)
        })
    }

    listenToScenarioTime(scenarioID) {
        console.log('listening to scnario time from:', scenarioID)
        if (this.scenarioTimeRef)
            this.scenarioTimeRef.off('value', this.rememberedTimeCallback)
        this.scenarioTimeRef = firebase
            .database()
            .ref('scenarios')
            .child(scenarioID)
            .child('models')
            .child('modelTime')
        this.rememberedTimeCallback = this.scenarioTimeRef.on('value', ev2 => {
            let val2 = Number(ev2.val())
            console.log('time', val2)
            this.setState({ modelTime: val2 })
        })
    }

    getSlide() {
        let a = this.state.infoPanel.slides
        let modelTime = this.state.modelTime || 0

        let slideKeys = Object.keys(a)
            .map(v => Number(v))
            .sort((x, y) => x - y)
        let key = slideKeys.filter(x => x <= modelTime).pop()
        console.log({ modelTime, slideKeys, key })
        return a[key]
    }

    render() {
        let content = <div className="editor" />
        let infoPanel = this.state.infoPanel

        if (infoPanel) {
            let defaultSlide = infoPanel.defaultSlide
            let slide = this.getSlide()

            let sty = defaultSlide.css
            let entityUrl = window.location.pathname.split('/edit')[0]
            console.log(entityUrl)

            content = (
                <div className="editor">
                    <div>
                        <h1>Time</h1>
                    </div>
                    <div>
                        <h1>HTML</h1>
                        <textarea value={slide.html || ''} />
                    </div>
                    <div>
                        <h1>CSS</h1>
                        <textarea value={slide.css || ''} />
                    </div>
                    <button>
                        <Link to="..">cancel</Link>
                    </button>
                    <button>
                        <Link to="#">save</Link>
                    </button>
                    <iframe src="{entityUrl}" />
                </div>
            )
        }

        return (
            <div>
                <h1>Edit Page</h1>
                <div>{this.props.errorMessage}</div>
                {content}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/InfoPanelEditPage.js